module.exports = __webpack_public_path__ + "static/media/Apple_Pay_Mark_RGB_041619.fe4f01ad.svg";